(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter =
          !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poo-pourri-ads-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pouri-landing-v2')) {
    customElements.define('pouri-landing-v2', class extends HTMLElement {
      connectedCallback() {
        this.toast = this.querySelector('.pv2__toast');
        this.tierButtons = [...this.querySelectorAll('[data-bundle-tier]')];
        this.bundleOptions = [...this.querySelectorAll('[data-bundle-option]')];
        this.bundleAdd = this.querySelector('[data-bundle-add]');
        this.addEventListener('click', (event) => {
          const tier = event.target.closest('[data-bundle-tier]');
          if (tier) {
            this.selectTier(tier, true);
            return;
          }
          const step = event.target.closest('[data-bundle-step]');
          if (step) {
            this.changeQuantity(step);
            return;
          }
          const bundleButton = event.target.closest('[data-bundle-add]');
          if (bundleButton) {
            this.addBundle(bundleButton);
            return;
          }
          const button = event.target.closest('[data-items]');
          if (!button) return;
          this.addItems(button);
        });
        if (this.tierButtons.length) this.selectTier(this.tierButtons[0]);
      }

      selectTier(button, shouldScroll = false) {
        this.tierButtons.forEach((tier) => {
          const active = tier === button;
          tier.classList.toggle('is-active', active);
          tier.setAttribute('aria-pressed', String(active));
        });
        this.currentTier = {
          home: Number(button.dataset.home),
          travel: Number(button.dataset.travel),
          discount: Number(button.dataset.discount),
          total: Number(button.dataset.total)
        };
        this.bundleOptions.forEach((option) => { option.dataset.quantity = '0'; });
        button.dataset.preset.split(',').forEach((item) => {
          const [variant, quantity] = item.split(':');
          const option = this.bundleOptions.find((candidate) => candidate.dataset.variant === variant);
          if (option) option.dataset.quantity = quantity;
        });
        this.querySelector('[data-travel-group]').hidden = this.currentTier.travel === 0;
        this.updateBundle();
        if (shouldScroll) this.querySelector('.pv2__bundle-builder').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      changeQuantity(button) {
        const option = button.closest('[data-bundle-option]');
        const size = option.dataset.size;
        const direction = Number(button.dataset.bundleStep);
        const current = Number(option.dataset.quantity || 0);
        const selected = this.bundleOptions
          .filter((candidate) => candidate.dataset.size === size)
          .reduce((total, candidate) => total + Number(candidate.dataset.quantity || 0), 0);
        const limit = this.currentTier[size];
        if (direction > 0 && selected >= limit) return;
        option.dataset.quantity = String(Math.max(0, current + direction));
        this.updateBundle();
      }

      updateBundle() {
        let regular = 0;
        const counts = { home: 0, travel: 0 };
        this.bundleOptions.forEach((option) => {
          const quantity = Number(option.dataset.quantity || 0);
          option.querySelector('output').textContent = String(quantity);
          counts[option.dataset.size] += quantity;
          regular += Number(option.dataset.price) * quantity;
        });
        this.querySelector('[data-home-count]').textContent = String(counts.home);
        this.querySelector('[data-home-limit]').textContent = String(this.currentTier.home);
        this.querySelector('[data-travel-count]').textContent = String(counts.travel);
        this.querySelector('[data-travel-limit]').textContent = String(this.currentTier.travel);
        const missing = Math.max(0, this.currentTier.home - counts.home) + Math.max(0, this.currentTier.travel - counts.travel);
        const calculatedSaving = Math.round(regular * this.currentTier.discount) / 100;
        const calculatedTotal = regular - calculatedSaving;
        const total = missing === 0 ? this.currentTier.total : calculatedTotal;
        const saving = missing === 0 ? regular - total : calculatedSaving;
        this.querySelector('[data-bundle-regular]').textContent = this.money(regular);
        this.querySelector('[data-bundle-saving]').textContent = this.money(saving);
        this.querySelector('[data-bundle-total]').textContent = this.money(total);
        this.querySelector('[data-bundle-status]').textContent = missing === 0
          ? this.dataset.bundleReady
          : this.dataset.bundleRemaining.replace('[count]', String(missing));
        this.bundleAdd.disabled = missing !== 0;
      }

      money(value) {
        const locale = this.lang === 'ar' ? 'ar-SA' : 'en-SA';
        return `SAR ${new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)}`;
      }

      addBundle(button) {
        const items = this.bundleOptions
          .map((option) => ({ id: Number(option.dataset.variant), quantity: Number(option.dataset.quantity || 0) }))
          .filter((item) => item.quantity > 0);
        this.addCartItems(button, items);
      }

      async addItems(button) {
        const items = button.dataset.items.split(',').map((item) => {
          const [id, quantity] = item.split(':');
          return { id: Number(id), quantity: Number(quantity) };
        });
        this.addCartItems(button, items);
      }

      async addCartItems(button, items) {
        const original = button.textContent;
        button.disabled = true;
        button.textContent = this.dataset.adding;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          button.textContent = this.dataset.added;
          this.showToast(this.dataset.added);
          window.setTimeout(() => { window.location.href = `${root}cart`; }, 450);
        } catch (error) {
          button.disabled = false;
          button.textContent = original;
          this.showToast(this.dataset.error);
        }
      }

      showToast(message) {
        this.toast.textContent = message;
        this.toast.classList.add('is-visible');
        window.setTimeout(() => this.toast.classList.remove('is-visible'), 2600);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
